import { render, staticRenderFns } from "./NotificationsFilter.vue?vue&type=template&id=0a868860&scoped=true&"
import script from "./NotificationsFilter.vue?vue&type=script&lang=js&"
export * from "./NotificationsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a868860",
  null
  
)

export default component.exports